"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NicaRecaptcha = function NicaRecaptcha(_ref) {
  var recaptchaRef = _ref.recaptchaRef,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    ref: recaptchaRef,
    sitekey: "6LfNdhsUAAAAAHxU9LqOu2w-ZW5UXmF32Wj37UYh",
    onChange: onChange
  });
};

var _default = NicaRecaptcha;
exports.default = _default;